import { render, staticRenderFns } from "./u-user-items-icon-text.vue?vue&type=template&id=d5f52f7e&scoped=true"
import script from "./u-user-items-icon-text.vue?vue&type=script&lang=js"
export * from "./u-user-items-icon-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f52f7e",
  null
  
)

export default component.exports